module.exports = __webpack_public_path__ + "images/480d6487faa8ad1ae748b43ad850bce8.png";